function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useCallback, useEffect, useRef, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Trans } from 'react-i18next';
import { DropableContainer, Dropdown, DropdownList, DropdownListContainer, DynamicPortal, KEYBOARD_KEYS, PER_PAGE_OPTIONS } from '@keen.io/ui-core';
import { useDynamicContentPosition, useKeypress } from '@keen.io/react-hooks';
import Label from '../../../../../Label';
import Row from '../../../../../Row';
import { paginationSettingsMotion } from '../../motion';
import { DroppableContainerWrapper, DropdownWrapper, RowsPerPageWrapper } from './RowsPerPage.styles';
import { DisabledPaginationInfo } from './components';

var RowsPerPage = function RowsPerPage(_ref) {
  var onChange = _ref.onChange,
      rowsPerPage = _ref.rowsPerPage,
      isPaginationEnabled = _ref.isPaginationEnabled;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      dropdownOpen = _useState2[0],
      setDropdownOpen = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      selectionIndex = _useState4[0],
      setIndex = _useState4[1];

  var PerPageOptions = PER_PAGE_OPTIONS.map(function (rowsPerPage) {
    return {
      label: rowsPerPage.toString(),
      value: rowsPerPage
    };
  });
  var selectedRowsPerPage = PER_PAGE_OPTIONS.includes(rowsPerPage) ? PerPageOptions.find(function (rowsPerPageOption) {
    return rowsPerPageOption.value === rowsPerPage;
  }) : PerPageOptions[0];
  var containerRef = useRef(null);

  var _useDynamicContentPos = useDynamicContentPosition(containerRef),
      setPosition = _useDynamicContentPos.setPosition,
      contentPosition = _useDynamicContentPos.contentPosition;

  useEffect(function () {
    if (dropdownOpen) {
      var rowsPerPageIndex = PerPageOptions.findIndex(function (_ref2) {
        var value = _ref2.value;
        return value === rowsPerPage;
      });
      var index = rowsPerPageIndex > 0 ? rowsPerPageIndex : 0;
      setIndex(index);
    }

    return function () {
      setIndex(null);
    };
  }, [dropdownOpen]);
  var keyboardHandler = useCallback(function (_e, keyCode) {
    switch (keyCode) {
      case KEYBOARD_KEYS.ENTER:
        var value = PerPageOptions[selectionIndex].value;
        onChange(value);
        setDropdownOpen(false);
        break;

      case KEYBOARD_KEYS.UP:
        if (selectionIndex > 0) {
          setIndex(selectionIndex - 1);
        }

        break;

      case KEYBOARD_KEYS.DOWN:
        if (selectionIndex === null) {
          setIndex(0);
        } else if (selectionIndex < PerPageOptions.length - 1) {
          setIndex(selectionIndex + 1);
        }

        break;

      case KEYBOARD_KEYS.ESCAPE:
        setDropdownOpen(false);
        break;
    }
  }, [selectionIndex, PerPageOptions]);
  useKeypress({
    keyboardAction: keyboardHandler,
    handledKeys: [KEYBOARD_KEYS.ENTER, KEYBOARD_KEYS.ESCAPE, KEYBOARD_KEYS.UP, KEYBOARD_KEYS.DOWN],
    addEventListenerCondition: dropdownOpen,
    eventListenerDependencies: [dropdownOpen, selectionIndex, PerPageOptions]
  });
  return React.createElement(RowsPerPageWrapper, null, React.createElement(DisabledPaginationInfo, {
    paginationDisabled: !isPaginationEnabled
  }), React.createElement(AnimatePresence, {
    initial: false
  }, isPaginationEnabled && React.createElement(motion.div, Object.assign({}, paginationSettingsMotion, {
    style: {
      overflow: 'hidden'
    }
  }), React.createElement(Row, null, React.createElement(Label, null, React.createElement(Trans, {
    i18nKey: 'widget_customization_table_settings.default_number_of_rows_per_page'
  })), React.createElement(DroppableContainerWrapper, {
    ref: containerRef
  }, React.createElement(DropableContainer, {
    variant: "secondary",
    onClick: function onClick() {
      setPosition();
      setDropdownOpen(!dropdownOpen);
    },
    isActive: dropdownOpen,
    value: selectedRowsPerPage.toString(),
    dropIndicator: true,
    onDefocus: function onDefocus() {
      return setDropdownOpen(false);
    }
  }, selectedRowsPerPage.label)), React.createElement(DynamicPortal, null, React.createElement(DropdownWrapper, {
    x: contentPosition.x,
    y: contentPosition.y,
    "data-testid": "rows-per-page-select"
  }, React.createElement(Dropdown, {
    isOpen: dropdownOpen
  }, React.createElement(DropdownListContainer, {
    scrollToActive: true,
    maxHeight: 150
  }, function (activeItemRef) {
    return React.createElement(DropdownList, {
      ref: activeItemRef,
      items: PerPageOptions,
      setActiveItem: function setActiveItem(_ref3) {
        var value = _ref3.value;
        return PerPageOptions[selectionIndex] && value === PerPageOptions[selectionIndex].value;
      },
      onClick: function onClick(_e, rowsPerPage) {
        return onChange(rowsPerPage.value);
      }
    });
  }))))))));
};

export default RowsPerPage;